export const enum AuthProvider {
  Google = 'google.com',
  Password = 'password',
}
